// #region Imports
// #endregion
const windowModule = {
    // #region Vars
    namespaced: true,
    // #endregion
    // #region Properties
    state: {
        modalWindows: [],
    },
    // #endregion
    // #region Mutations
    mutations: {
        startup(appHost) {
            //DO nothing
        }
    },
    // #endregion
};
export default windowModule;
